import type { FC } from "react";
import classNames from "classnames";

interface IGAVerifiedIcon {
    isActive: boolean;
    size: string;
}

const GAVerifiedIcon: FC<IGAVerifiedIcon> = ({ isActive, size }) => {
    return (
        <div
            className={classNames(
                "GAVerified-icon-container",
                `GAVerified-icon--${size}`,
                { ["GAVerified-icon--active"]: isActive },
                { ["GAVerified-icon--inactive"]: !isActive },
            )}
        ></div>
    );
};

export default GAVerifiedIcon;
